var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorMomentum3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "304.5px",
    height: "184.833px",
    viewBox: "0 0 304.5 184.833",
    enableBackground: "new 0 0 304.5 184.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mom0_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mom1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mom2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "mom3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M183.154,83.124v-0.051c0.162,0.033,0.329,0.051,0.5,0.051c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.171,0-0.338,0.018-0.5,0.05v-0.05h-25v5H183.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M209.455,68.124v-0.021c0.067,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.132,0.014-0.199,0.02v-0.02h-51v5H209.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M236.455,53.124c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5h-78v5H236.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M263.455,38.124v-0.021c0.066,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.133,0.014-0.199,0.02v-0.02h-105v5H263.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M290.686,23.124V23.12c1.367-0.018,2.469-1.127,2.469-2.496c0-1.371-1.102-2.48-2.469-2.498v-0.002 H158.154v5H290.686z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 290.686,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 263.756,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 236.756,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 209.756,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 182.903,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 111.629,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 111.629,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 111.629,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.756,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 111.629,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 111.629,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.903,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 81.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 76.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.756,
    y: 71.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 81.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 76.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 71.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 66.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 61.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.902,
    y: 56.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 81.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 76.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 71.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 66.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 61.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 56.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 51.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 46.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.756,
    y: 41.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 81.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 76.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 71.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 66.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 61.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 56.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 51.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 46.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 41.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 36.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 31.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.686,
    y: 26.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: 152.25,
    y: 2.562,
    fill: "#1C75BC",
    width: 2,
    height: 179.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.249,
    y: 91.895,
    fill: "#1C75BC",
    width: 300.001,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EE2929",
    d: "M123.92,102.396v0.051c-0.162-0.033-0.328-0.051-0.5-0.051c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5c0.172,0,0.338-0.018,0.5-0.051v0.051h25v-5H123.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D12727",
    d: "M97.619,117.396v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h51v-5H97.619z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M70.619,132.396c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5h78v-5H70.619z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M43.619,147.396v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h105v-5H43.619z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M16.389,162.396v0.004c-1.366,0.018-2.469,1.127-2.469,2.496c0,1.371,1.103,2.48,2.469,2.498v0.002 H148.92v-5H16.389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 16.389,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 43.318,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 70.318,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12727",
    cx: 97.318,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EE2929",
    cx: 124.172,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 25.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 30.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 35.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 40.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 45.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 50.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 55.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 60.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 65.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 70.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 75.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 80.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 85.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 25.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 30.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 35.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 40.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 45.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 50.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 55.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 60.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 65.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 70.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 75.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 80.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 85.89,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.318,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.172,
    y: 96.396,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 96.396,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 101.396,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 106.396,
    fill: "#EE2929",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.318,
    y: 111.395,
    fill: "#EE2929",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 111.395,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.172,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 111.395,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 131.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 136.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.318,
    y: 141.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 111.395,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 131.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 136.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 141.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 146.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 151.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.389,
    y: 156.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M12.633,13.405c0-1.465,0.357-2.703,1.072-3.713c0.715-1.012,1.672-1.517,2.867-1.517 c2.496,0,3.743,1.821,3.743,5.464c0,1.704-0.337,3.064-1.011,4.08s-1.619,1.523-2.834,1.523c-1.309,0-2.275-0.469-2.9-1.406 S12.633,15.422,12.633,13.405z M14.609,13.537c0,1.431,0.14,2.483,0.418,3.157s0.74,1.01,1.385,1.01 c0.697,0,1.193-0.303,1.486-0.912c0.293-0.607,0.439-1.689,0.439-3.248c0-1.449-0.141-2.451-0.421-3.002 c-0.281-0.553-0.741-0.828-1.381-0.828C15.252,9.714,14.609,10.988,14.609,13.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M42.833,19.238v-7.734l-2.182,1.312v-1.832c1.4-0.678,2.51-1.518,3.324-2.52h0.762v10.774H42.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M67.219,19.097V18.54l3.398-5.003c0.678-1.001,1.018-1.843,1.018-2.526 c0-0.811-0.486-1.217-1.457-1.217c-0.742,0-1.341,0.394-1.795,1.18l-1.281-1.011c0.254-0.513,0.652-0.938,1.197-1.278 c0.544-0.339,1.146-0.509,1.805-0.509c1.1,0,1.959,0.251,2.578,0.751c0.621,0.5,0.931,1.195,0.931,2.084 c0,0.814-0.397,1.83-1.194,3.047l-2.197,3.347h4.029v1.692H67.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M93.964,18.195l0.952-1.472c0.566,0.6,1.182,0.9,1.846,0.9c1.211,0,1.816-0.568,1.816-1.707 c0-0.518-0.176-0.938-0.527-1.264c-0.352-0.324-0.825-0.486-1.421-0.486h-0.337V12.6h0.285c1.094,0,1.641-0.456,1.641-1.37 c0-0.957-0.51-1.436-1.53-1.436c-0.527,0-1.04,0.25-1.538,0.748L94.257,9.23c0.229-0.283,0.589-0.53,1.077-0.739 c0.488-0.211,0.977-0.315,1.465-0.315c1.068,0,1.902,0.244,2.5,0.732c0.599,0.488,0.898,1.172,0.898,2.051 c0,1.045-0.449,1.841-1.348,2.388c1.137,0.547,1.706,1.44,1.706,2.681c0,1.021-0.339,1.812-1.015,2.373 s-1.609,0.843-2.801,0.843C95.656,19.243,94.73,18.894,93.964,18.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M126.127,16.291v2.806h-1.831v-2.806h-4.886V15.2l5.882-6.878h0.835v6.46h1.084v1.509H126.127z  M124.296,11.56l-2.754,3.223h2.754V11.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M179.563,176.036l0.755-1.568c0.775,0.605,1.442,0.908,1.999,0.908c1.23,0,1.846-0.756,1.846-2.27 c0-0.729-0.14-1.258-0.417-1.594c-0.279-0.334-0.745-0.502-1.399-0.502c-0.591,0-1.167,0.291-1.729,0.873l-0.755-0.492v-5.316 h5.779v1.619h-3.947v1.918c0.322-0.146,0.707-0.219,1.156-0.219c1.055,0,1.867,0.305,2.436,0.914 c0.568,0.611,0.854,1.475,0.854,2.594c0,2.729-1.271,4.094-3.816,4.094C181.27,176.995,180.35,176.675,179.563,176.036z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M210.215,165.907l1.01,1.068c-0.727,0.381-1.389,0.881-1.984,1.502 c-0.596,0.619-1.006,1.232-1.23,1.838c0.508-0.229,0.947-0.344,1.318-0.344c1.011,0,1.822,0.314,2.436,0.941 c0.612,0.627,0.919,1.475,0.919,2.545c0,1.055-0.313,1.908-0.94,2.561c-0.629,0.65-1.42,0.977-2.377,0.977 c-2.5,0-3.75-1.561-3.75-4.68c0-1.309,0.481-2.633,1.445-3.973C208.025,167.001,209.076,166.19,210.215,165.907z  M207.592,173.421c0,1.305,0.555,1.955,1.663,1.955c0.454,0,0.815-0.162,1.084-0.486s0.403-0.777,0.403-1.359 c0-0.596-0.141-1.066-0.422-1.416s-0.643-0.523-1.088-0.523C208.139,171.591,207.592,172.2,207.592,173.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M236.288,177.563h-2.087c0.795-2.451,2.162-5.457,4.102-9.018h-4.915v-1.758h7.397v0.814l-0.967,1.822 c-0.317,0.615-0.652,1.289-1.004,2.02c-0.352,0.729-0.693,1.471-1.025,2.227c-0.332,0.754-0.625,1.459-0.879,2.115 C236.656,176.444,236.449,177.036,236.288,177.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M261.934,170.976c-0.391-0.264-0.711-0.613-0.959-1.049c-0.25-0.434-0.374-0.869-0.374-1.303 c0-0.826,0.292-1.48,0.875-1.967s1.332-0.729,2.245-0.729c0.981,0,1.748,0.242,2.3,0.729s0.827,1.145,0.827,1.975 c0,0.434-0.153,0.895-0.461,1.381c-0.308,0.484-0.645,0.826-1.011,1.021c0.464,0.215,0.892,0.602,1.285,1.164 c0.394,0.561,0.59,1.088,0.59,1.582c0,1.016-0.319,1.805-0.96,2.369c-0.639,0.564-1.508,0.846-2.607,0.846 c-1.107,0-1.964-0.275-2.566-0.828c-0.604-0.551-0.904-1.348-0.904-2.387c0-0.537,0.159-1.064,0.479-1.582 C261.012,171.681,261.426,171.272,261.934,170.976z M263.516,171.743c-0.933,0.527-1.398,1.207-1.398,2.037 c0,0.459,0.145,0.84,0.436,1.143c0.29,0.303,0.668,0.453,1.131,0.453c0.488,0,0.888-0.133,1.198-0.398 c0.31-0.266,0.465-0.617,0.465-1.051C265.347,173.185,264.736,172.456,263.516,171.743z M263.896,170.243 c0.273-0.127,0.516-0.363,0.725-0.707c0.211-0.344,0.315-0.656,0.315-0.934c0-0.322-0.111-0.58-0.333-0.77 c-0.223-0.191-0.517-0.285-0.883-0.285c-0.811,0-1.216,0.354-1.216,1.061c0,0.313,0.149,0.633,0.446,0.957 C263.25,169.89,263.564,170.116,263.896,170.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M289.904,177.054l-1.011-1.068c1.484-0.82,2.534-1.893,3.149-3.217 c-0.327,0.146-0.744,0.221-1.252,0.221c-1.006,0-1.816-0.313-2.432-0.938s-0.924-1.475-0.924-2.549 c0-1.064,0.315-1.926,0.945-2.586c0.63-0.658,1.421-0.988,2.373-0.988c2.5,0,3.75,1.572,3.75,4.717 c0,1.309-0.482,2.633-1.447,3.973C292.093,175.96,291.042,176.771,289.904,177.054z M289.377,169.429 c0,0.602,0.142,1.074,0.425,1.422c0.283,0.346,0.645,0.52,1.084,0.52c1.094,0,1.641-0.609,1.641-1.83 c0-1.328-0.554-1.992-1.663-1.992c-0.453,0-0.814,0.166-1.084,0.502C289.512,168.384,289.377,168.843,289.377,169.429z"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "mom4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "mom5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "mom6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "mom7"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "mom8"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "mom9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorMomentum3);
export default __webpack_public_path__ + "static/media/indicator-momentum-3.d2b1b051b6ab6e5fac065a8b447ea215.svg";
export { ForwardRef as ReactComponent };